import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useHistory } from "react-router-dom";
import { Button, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';

import { bookingActions, getTripDates, isWidget } from "../../utils/utils";
import { ReactComponent as Calendar } from "../../../svg/Black/Calendar.svg";
import { ReactComponent as Boat } from "../../../svg/Black/Boat.svg";
import { Tent } from "../../../svg/Black/Tent.svg";
import clsx from "clsx";


const useStyles = makeStyles(() => ({
    accordeonRow: {
        position: 'relative',
        padding: '20px',
        display: 'grid',
        gap: '10px',
        gridTemplateColumns: '3fr 2fr',
        borderBottom: '1px solid #C0C0C0',
        '&:last-child': {
            borderBottom: 'unset',
        },
        '@media (max-width: 1024px)': {
            gridTemplateColumns: '1fr minmax(280px, 40%)'
        },
        '@media (max-width: 580px)': {
            display: 'block'
        },
    },
    tripRow: {
        display: 'block'
    },
    OnSpecial: {
        boxShadow: 'inset 0 0 5px 1px red',
    },
    accordeonColumn: {
        display: 'grid',
        gap: '10px',
        '&:first-child': {
            gap: '10px',
            gridTemplateColumns: '160px 125px minmax(120px, 1fr)',
            '@media (max-width: 1200px)': {
                gridTemplateColumns: '1fr 1fr',
                gridTemplateRows: 'repeat(2, 1fr)',
            },
        },
        '&:last-child': {
            gridTemplateColumns: 'minmax(96px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr)',
            justifyContent: 'flex-end',
            '@media (max-width: 1200px)': {
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateRows: 'repeat(2, 1fr)',
                paddingLeft: '10px',
            },
            '@media (max-width: 500px)': {
                paddingLeft: '0px',
            },
        },
        '@media (max-width: 1024px)': {
            gap: '10px',
        },
    },
    accordeonItem: {
        fontSize: '1.5rem',
        display: 'flex',
        alignItems: 'flex-end',
    },
    accordeonItemAction: {
        '@media (max-width: 1200px)': {
            gridColumn: 'span 2',
        },
    },
    accordeonItemAvailable: {
        justifyContent: 'flex-end',
        '@media (max-width: 1200px)': {
            justifyContent: 'center',
        },
    },
    special: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        position: 'absolute',
        width: '27px',
        left: '-27px',
        backgroundColor: '#FF0000',
        color: '#fff',
        fontSize: '12px',
        fontWeight: '500',
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        letterSpacing: '0.02857em',
        writingMode: 'vertical-lr',
        transform: 'rotate(-180deg)',
        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
        '@media (max-width: 1024px)': {
            writingMode: 'unset',
            padding: '7px 15px',
            position: 'relative',
            left: 'unset',
            width: '100%',
            transform: 'unset'
        },
    },
    combo: {
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '7px 15px',
        backgroundColor: '#000',
        color: '#fff',
        fontSize: '12px',
        fontWeight: '500',
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        letterSpacing: '0.02857em',
        '@media (max-width: 1024px)': {
            width: '100%',
        },
    },
    icon: {
        position: 'relative',
        color: '#333870',
        marginRight: '5px',
        flex: '0 0 25px',
    },
    available: {
        color: '#F50802',
        fontSize: '1.5rem',
        textAlign: 'center'
    },
    regular: {
        color: '#000000',
        fontSize: '1.5rem',
        textAlign: 'center'
    },
    price: {
        fontWeight: '700',
        fontSize: '2.5rem'
    },
    contrastPrice: {
        fontSize: "12px",
        textDecoration: "line-through",
        color: "red",
    },
    sub: {
        verticalAlign: 'super',
        fontSize: '12px',
    },
    accordeonItemLenght: {
        justifyContent: 'center',
        '@media (max-width: 1200px)': {
            justifyContent: 'flex-start',
            paddingLeft: '10px'
        },
    },

    // Estilo para dateItem y locationItem en versión móvil
    dateItem: {
        '@media (max-width: 580px)': {
            minWidth: '160px', // Aumenta ligeramente la longitud mínima
        },
    },
    locationItem: {
        '@media (max-width: 580px)': {
            minWidth: '160px', // Aumenta ligeramente la longitud mínima
        },
    },
}));


const CardTripAccordionRow = ({ trip, isOnlyDealerTrips, tripClassId }) => {
    const history = useHistory();
    const classes = useStyles();
    const special = Array.isArray(trip?.adventures) ? trip.adventures.find(adventure => adventure.name.includes("Super savings")) : undefined;
    const comboAdventure = Array.isArray(trip?.adventures) ? trip.adventures.find(adventure => adventure.name.includes("Combo")) : undefined;

    const secondaryTrip = trip?.SecondaryTripClassesInfo?.length ? trip.SecondaryTripClassesInfo : null;

    const combo = comboAdventure
        ? (
            [
                // Filters secondaryTrip that do not contain "Combo" in the class
                ...(secondaryTrip?.filter(stc => stc.tripClassId !== tripClassId && !stc.class.includes("Combo"))
                    .map(stc => stc.class) || []),

                // Check if trip_class_info.class should be included and does not contain "Combo"
                ...(trip.trip_class_info.TripClassId !== tripClassId && !trip.trip_class_info.class.includes("Combo")
                    ? [trip.trip_class_info.class]
                    : [])
            ].join(' / ') || ''
        ) : '';

    let urlTrip;
    let prefixUrl;
    if (!isWidget())
        urlTrip = `${window['siteUrl']}booking/${trip['TripId']}/`;
    else
        urlTrip = `${window['widgetURL']}plugin/${trip['TripId']}/`;
    if (!isWidget())
        prefixUrl = `booking/${trip['TripId']}`;
    else
        prefixUrl = `plugin/${trip['TripId']}`;

    let suffixLink = 'wait-list';
    if ((isWidget() && isOnlyDealerTrips) || parseInt(trip['visible']) === -2 || parseInt(trip['visible']) === -1) {
        suffixLink = 'inquiry';
    } else if (parseInt(trip['available']) > 0) {
        suffixLink = 'select-room';
    }
    const handleTrip = () => {
        const searchParams = new URLSearchParams(window.location.search);
        bookingActions(
            'Availability Page',
            'Reserve now',
            `${trip.TripId} - ${trip.shortcomment} `,
            trip.locationInfo.location,
            trip.boarddate,
            parseFloat(trip.lowestPrice).formatMoney(0));
            sessionStorage.removeItem('searchParams');
            if([...searchParams].length > 0) {
                sessionStorage.setItem('searchParams', window.location.search);
            }         
            history.push(`${prefixUrl}/${suffixLink}`);
    };
    const availableSpaces = parseInt(trip.available);
    let messageSpace;

    if (!isOnlyDealerTrips) {
        const spaceText = trip.trip_class_info?.tripType?.toLowerCase().includes('shorebased')
            ? 'spot'
            : (trip.trip_class_info === null ? 'space' : 'berth');

        if (parseInt(trip['visible']) === -2 || parseInt(trip['visible']) === -1)
            messageSpace = '';
        else if (availableSpaces > 0 && availableSpaces <= 5) {
            messageSpace = `${availableSpaces} ${spaceText}${availableSpaces > 1 ? 's' : ''} available`;
        } else if (availableSpaces > 5) {
            messageSpace = `> 5 ${spaceText}s available`;
        } else {
            messageSpace = 'Full';
        }
    }

    const findLowestPriceIndex = (onSpecial) => {
        let lowestPrice = Infinity;
        let lowestPriceIndex = null;

        // Recorrer cada precio dentro del objeto onSpecial
        for (const key in onSpecial) {
            if (onSpecial[key]?.current?.pretax !== undefined) {
                const currentPrice = onSpecial[key].current.pretax;

                if (currentPrice > 0 && currentPrice < lowestPrice) {
                    lowestPrice = currentPrice;
                    lowestPriceIndex = key;
                }
            }
        }

        return lowestPriceIndex;
    };
    // Verificar si existe un objeto "special" y "OnSpecial"
    let lowestPrice= trip.lowestPrice;
    let prevPrice = undefined;
    if (special !== undefined && trip.OnSpecial) {
        const lowestPriceIndex = findLowestPriceIndex(trip.OnSpecial);
        lowestPrice = trip.OnSpecial[lowestPriceIndex]?.current?.pretax;
        prevPrice = trip.OnSpecial[lowestPriceIndex]?.prev?.pretax;
    }


    const classNameSpace = availableSpaces > 0 && availableSpaces < 3 ? classes.available :
        availableSpaces > 3 ? classes.regular : classes.available;

    return (
        <div style={{ position: 'relative' }} className={clsx(classes.tripRow, { [classes.OnSpecial]: special })}>
            {special !== undefined && <div className={classes.special}>SPECIAL</div>}
            {comboAdventure && combo !=='' && <div className={classes.combo}>Combo trip with {combo}</div>}
            <div className={classes.accordeonRow}
                style={{ padding: combo !== null || special !== undefined ? '10px 15px 20px 15px' : '20px' }}>
                <div className={classes.accordeonColumn}>
                    <div className={`${classes.accordeonItem} ${classes.dateItem}`}>
                        <Calendar className={classes.icon} style={{ top: '2px' }} />
                        {getTripDates(trip)}
                    </div>
                    <div className={`${classes.accordeonItem} ${classes.accordeonItemLenght}`}>
                        {parseInt(trip.length) + 1} days / {trip.length} nights
                    </div>
                    <div className={`${classes.accordeonItem} ${classes.locationItem}`}>
                        {trip.trip_class_info?.tripType?.toLowerCase().includes('shorebased') ?
                            <Tent className={classes.icon} style={{ top: '2px' }} /> :
                            <Boat className={classes.icon} style={{ top: '2px' }} />
                        }
                        {trip.locationInfo?.location}
                    </div>
                </div>
                <div className={classes.accordeonColumn}>
                    <div className={`${classes.accordeonItem} ${classes.accordeonItemAvailable}`}>
                        {
                            <Typography
                                variant="span"
                                component="span"
                                className={classNameSpace}
                                sx={availableSpaces === 0 ? { textTransform: 'uppercase' } : {}}
                            >
                                {messageSpace}
                            </Typography>
                        }
                    </div>
                    <div className={classes.accordeonItem}
                        style={{
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Typography
                            gutterBottom
                            variant="h3"
                            component="h3"
                            sx={{
                                fontSize: '21px',
                                lineHeight: '24px',
                                margin: 0
                            }}
                        >
                            <sup className={classes.sub}>From</sup>
                            {special && prevPrice && <><span className={classes.contrastPrice}>&nbsp;${parseFloat(prevPrice).formatMoney(0)}</span><br/></>}
                            <span className={classes.price}>&nbsp;${parseFloat(lowestPrice).formatMoney(0)}</span>
                        </Typography>
                    </div>
                    <div className={`${classes.accordeonItem} ${classes.accordeonItemAction}`}>
                        {suffixLink === 'select-room' ?
                            <Grid container>
                                <Grid item xs>
                                    <Button
                                        color={'primary'}
                                        variant={'contained'}
                                        fullWidth
                                        sx={{ padding: '5px', fontSize: '14px', textTransform: 'uppercase', }}
                                        // href={urlTrip + suffixLink}
                                        onClick={handleTrip}
                                    >
                                        Reserve Now
                                    </Button>
                                </Grid>
                            </Grid>
                            :
                            <Grid container>
                                <Grid item xs>
                                    <Button
                                        variant={'contained'}
                                        fullWidth
                                        sx={{
                                            padding: '5px',
                                            fontSize: '14px',
                                            backgroundColor: '#C0C0C0',
                                            color: '#000',
                                            textTransform: 'uppercase',
                                            ":hover": {
                                                backgroundColor: '#F3F3F3',
                                            }
                                        }}
                                        onClick={handleTrip}
                                    >
                                        {suffixLink === 'inquiry' ? 'Inquire' : 'Waitlist Me'}
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardTripAccordionRow;